import { render, staticRenderFns } from "./RadioOption.vue?vue&type=template&id=42c706b7&scoped=true&"
import script from "./RadioOption.vue?vue&type=script&lang=js&"
export * from "./RadioOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c706b7",
  null
  
)

export default component.exports